<main class="policy-page">
  <section class="policy-hero">
    <div class="policy-container">
      <app-navigate-back class="mb-4"></app-navigate-back>
      <h1 class="policy-title">Cyber Security</h1>
      <p class="policy-subtitle">Secure your smart connected vehicle</p>
    </div>
  </section>

  <section class="policy-body">
    <div class="policy-container policy-copy policy-stack text-[#0A0A0A]">
      <section class="policy-section">
        <h2 class="policy-section-title">Security Measures</h2>
        <ul class="policy-list">
          <li *ngFor="let securityMeasure of securityMeasures">
            {{ securityMeasure }}
          </li>
        </ul>
      </section>

      <section class="policy-section">
        <h2 class="policy-section-title">Mobile Applications</h2>
        <ul class="policy-list">
          <li *ngFor="let mobileApplication of mobileApplications">
            {{ mobileApplication }}
          </li>
        </ul>
      </section>

      <section class="policy-section">
        <h2 class="policy-section-title">Web Applications</h2>
        <ul class="policy-list">
          <li *ngFor="let webApplication of webApplications">
            {{ webApplication }}
          </li>
        </ul>
      </section>

      <section class="policy-section">
        <h2 class="policy-section-title">System</h2>
        <ul class="policy-list">
          <li *ngFor="let systemItem of system">
            {{ systemItem }}
          </li>
        </ul>
      </section>
    </div>
  </section>
</main>